'use strict';

angular.module('shiftTraderApp')
  .service('SandboxService', ['$rootScope',
    function ($rootScope) {
      var sandboxData = {
        mode: false,
        info: {}
      }

      this.setSandboxData = function(data) {
        sandboxData = data
        $rootScope.$broadcast('sa:sandboxData', sandboxData);
      }

      this.getSandboxData = function() {
        return sandboxData
      }

      this.getSandboxMode = function() {
        return sandboxData.mode
      }
    }])
